<template>
  <div class="wrapper nav-collapsed menu-collapsed">
    <div data-active-color="white" data-background-color="black" data-image="/app-assets/img/sidebar-bg/01.jpg" class="app-sidebar">
      <div class="sidebar-header">
        <div class="logo clearfix">
          <router-link :to="{ name: 'home'}" class="logo-text float-left"> <span class="text align-middle">Admin</span></router-link>
          <a id="sidebarToggle" href="javascript:;" class="nav-toggle d-none d-sm-none d-md-none d-lg-block"><i data-toggle="collapsed" class="ft-circle toggle-icon"></i></a><a id="sidebarClose" href="javascript:;" class="nav-close d-block d-md-block d-lg-none d-xl-none"><i class="ft-circle"></i></a></div>
      </div>
      <div class="sidebar-content">
        <div class="nav-container">

          <ul id="main-menu-navigation" data-menu="menu-navigation" class="navigation navigation-main">
            <li class="nav-item">
              <router-link :to="{ name: 'home'}"><i class="icon-home"></i><span data-i18n="" class="menu-title">{{ $t("labels.dashboard") }}</span></router-link>
            </li>
            <li class="nav-item" v-if="$store.state.user.role === 'admin'">
              <router-link :to="{ name: 'lov'}"><i class="icon-settings"></i><span data-i18n="" class="menu-title">{{ $t("labels.settings") }}</span></router-link>
            </li>
            <li class="has-sub nav-item" v-if="$store.state.user.role === 'admin'">
              <a href="#">
                <i class="icon-list"></i>
                <span data-i18n="" class="menu-title">{{ $t("labels.news") }}</span>
              </a>
              <ul class="menu-content">
                <li>
                  <router-link :to="{ name: 'newsList'}">{{ $t("labels.manageArticles") }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'newArticle'}">{{ $t("labels.newArticle") }}</router-link>
                </li>
              </ul>
            </li>
            <li class="has-sub nav-item">
              <a href="#"><i class="icon-grid"></i><span class="menu-title">{{ $t("labels.patients") }}</span></a>
              <ul class="menu-content">
                <li v-for="patient in patients" :key="patient._id">
                  <a href="#" @click.prevent="gotoPatient(patient)" class="menu-item" :class="{'default-patient': patient.default}">{{ patient.name }} {{ patient.surname }}</a>
                </li>
                <li>
                  <a href="#" @click.prevent="gotoNewPatient">{{ $t("labels.newPatient") }}</a>
                </li>
                <li>
                  <router-link :to="{ name: 'emergencyCertificates'}">{{ $t("labels.emergencyCertificates") }}</router-link>
                </li>
              </ul>
            </li>
            <li class="has-sub nav-item" v-if="$store.state.user.role === 'admin' || $store.state.user.role === 'dravetnet'">
              <a href="#"><i class="icon-list"></i><span class="menu-title">{{ $t("labels.reports") }}</span></a>
              <ul class="menu-content">
                <li>
                   <router-link :to="{ name: 'drugReport'}">{{ $t("labels.drugReport") }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'userReport'}">{{ $t("labels.userReport") }}</router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item" v-if="$store.state.user.role === 'user'">
              <router-link :to="{ name: 'publicNews'}"><i class="icon-list"></i><span class="menu-title">{{ $t("labels.news") }}</span></router-link>
            </li>
            <li class="nav-item" v-if="$store.state.user.role === 'user'">
              <router-link :to="{ name: 'support'}"><i class="icon-support"></i><span data-i18n="" class="menu-title">{{ $t("labels.newSuggestion") }}</span></router-link>
            </li>
            <li class="nav-item" v-if="$store.state.user.role === 'admin'">
              <router-link :to="{ name: 'users'}"><i class="icon-user"></i><span class="menu-title">{{ $t("labels.users") }}</span></router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="sidebar-background"></div>
    </div>

    <nav class="navbar navbar-expand-lg navbar-light bg-faded">
      <div class="container-fluid">
        <div class="navbar-header">
          <router-link :to="{ name: 'home'}">
            <img src="/app-assets/img/logo-dravet-diary.png" alt='Logo Dravet Diary'/>
          </router-link>
        </div>
        <div class="navbar-container">
          <div id="navbarSupportedContent" class="collapse navbar-collapse">
            <ul class="navbar-nav">
              <li class="dropdown nav-item mt-1"><a id="dropdownBasic" href="#" data-toggle="dropdown" class="nav-link position-relative dropdown-toggle">
                  <img :src="'/app-assets/img/flags/' + currentLocale + '.png'" alt="English Flag" class="langimg" v-if="currentLocale" />
                  <i class="ft-flag blue-grey darken-4" v-else></i>
                  <span class="selected-language d-none"></span>
                  </a>
                <div class="dropdown-menu dropdown-menu-right">
                  <div class="arrow_box_right">
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="en" class="dropdown-item py-1" v-show="currentLocale != 'en'"><img src="/app-assets/img/flags/en.png" alt="English Flag" class="langimg" /><span> English</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="it" class="dropdown-item"      v-show="currentLocale != 'it'"><img src="/app-assets/img/flags/it.png" alt="Italian Flag" class="langimg" /><span> Italian</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="fr" class="dropdown-item"      v-show="currentLocale != 'fr'"><img src="/app-assets/img/flags/fr.png" alt="French Flag" class="langimg" /><span> French</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="es" class="dropdown-item py-1" v-show="currentLocale != 'es'"><img src="/app-assets/img/flags/es.png" alt="Spanish Flag" class="langimg" /><span> Spanish</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="de" class="dropdown-item"      v-show="currentLocale != 'de'"><img src="/app-assets/img/flags/de.png" alt="German Flag" class="langimg" /><span> German</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="nl" class="dropdown-item"      v-show="currentLocale != 'nl'"><img src="/app-assets/img/flags/nl.png" alt="Netherland Flag" class="langimg" /><span> Netherland</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="cr" class="dropdown-item"      v-show="currentLocale != 'cr'"><img src="/app-assets/img/flags/cr.png" alt="Croatian Flag" class="langimg" /><span> Croatian</span></a>
                  </div>
                </div>
              </li>
              <!--
              <li class="dropdown nav-item mt-1"><a id="dropdownBasic2" href="#" data-toggle="dropdown" class="nav-link position-relative dropdown-toggle"><i
                    class="ft-bell blue-grey darken-4"></i><span class="notification badge badge-pill badge-danger">4</span>
                  <p class="d-none">{{ $t("labels.notifications") }}</p>
                </a>
                <div class="notification-dropdown dropdown-menu dropdown-menu-right">
                  <div class="arrow_box_right">
                    <div class="noti-list"><a class="dropdown-item noti-container py-2"><i class="ft-share info float-left d-block font-medium-4 mt-2 mr-2"></i><span
                          class="noti-wrapper"><span class="noti-title line-height-1 d-block text-bold-400 info">New
                            Order Received</span><span class="noti-text">Lorem ipsum dolor sit ametitaque in, et!</span></span></a><a
                        class="dropdown-item noti-container py-2"><i class="ft-save warning float-left d-block font-medium-4 mt-2 mr-2"></i><span
                          class="noti-wrapper"><span class="noti-title line-height-1 d-block text-bold-400 warning">New
                            User Registered</span><span class="noti-text">Lorem ipsum dolor sit ametitaque in </span></span></a><a
                        class="dropdown-item noti-container py-2"><i class="ft-repeat danger float-left d-block font-medium-4 mt-2 mr-2"></i><span
                          class="noti-wrapper"><span class="noti-title line-height-1 d-block text-bold-400 danger">New
                            Order Received</span><span class="noti-text">Lorem ipsum dolor sit ametest?</span></span></a><a
                        class="dropdown-item noti-container py-2"><i class="ft-shopping-cart success float-left d-block font-medium-4 mt-2 mr-2"></i><span
                          class="noti-wrapper"><span class="noti-title line-height-1 d-block text-bold-400 success">New
                            Item In Your Cart</span><span class="noti-text">Lorem ipsum dolor sit ametnatus aut.</span></span></a><a
                        class="dropdown-item noti-container py-2"><i class="ft-heart info float-left d-block font-medium-4 mt-2 mr-2"></i><span
                          class="noti-wrapper"><span class="noti-title line-height-1 d-block text-bold-400 info">New
                            Sale</span><span class="noti-text">Lorem ipsum dolor sit ametnatus aut.</span></span></a><a
                        class="dropdown-item noti-container py-2"><i class="ft-box warning float-left d-block font-medium-4 mt-2 mr-2"></i><span
                          class="noti-wrapper"><span class="noti-title line-height-1 d-block text-bold-400 warning">Order
                            Delivered</span><span class="noti-text">Lorem ipsum dolor sit ametnatus aut.</span></span></a></div><a
                      class="noti-footer primary text-center d-block border-top border-top-blue-grey border-top-lighten-4 text-bold-400 py-1">Read
                      All Notifications</a>
                  </div>
                </div>
              </li>
              -->
              <li class="dropdown nav-item mr-0"><a id="dropdownBasic3" href="#" data-toggle="dropdown" class="nav-link position-relative dropdown-user-link dropdown-toggle"><span
                    class="avatar avatar-online">
                    <img id="navbar-avatar" src="/app-assets/img/avatars/user.png"
                      alt="avatar" /></span>
                  <p class="d-none">{{ $t("labels.userSettings") }}</p>
                </a>
                <div aria-labelledby="dropdownBasic3" class="dropdown-menu dropdown-menu-right">
                  <div class="arrow_box_right">
                    <router-link :to="{ name: 'me'}" class="dropdown-item py-1"><i class="ft-edit mr-2"></i><span>{{ $t("labels.myProfile") }}</span></router-link>
                    <div class="dropdown-divider"></div>
                    <a @click="logout()" class="dropdown-item" ><i class="ft-power mr-2"></i><span>{{ $t("labels.logout") }}</span></a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AuthService from '../services/auth'
import UserService from '../services/user'
import PatientService from '../services/patient'
import StorageService from '../services/storage'
import moment from 'moment'
export default {
  metaInfo: {
    bodyAttrs: {
      class: '2-columns'
    }
  },
  data() {
    return {
      currentLocale: null
    }
  },
  mounted: async function () {
    $('body').append('<script src="/app-assets/vendors/js/chartist.min.js"/>')
    $('body').append('<script src="/app-assets/js/app-sidebar.js"/>')
    $('body').append('<script src="/app-assets/js/notification-sidebar.js"/>')
    $('body').append('<script src="/app-assets/js/dashboard-ecommerce.js"/>')
    let user = await UserService.me()
    if (user.data.language) {
      this.$i18n.locale = user.data.language
      this.currentLocale = user.data.language
      moment.locale(this.$store.getters.userLang)
    }
    this.$store.dispatch('allPatients')
  },
  computed: mapState([
    'patients'
  ]),
  methods: {
    logout: async function () {
      try {
        await AuthService.logout()
        this.$router.push({ name: 'login' })
      } catch (e) {
        this.$miniToastr.error(e, 'Error')
      }
    },
    gotoPatient: async function(patient) {
      let formData = new FormData()
      let currentDefault = this.$store.state.patients.find(function(patient) {
        return patient.default == true
      })
      if (currentDefault === null || currentDefault === undefined) {
        currentDefault = this.$store.state.patients[0]
      }
      currentDefault.default = false
      patient.default = true
      patient.sideNav = true
      formData.append('patient', JSON.stringify(patient))
      const result = await PatientService.update(patient._id, formData)
      if (result) {
        this.$router.push({ name: 'showPatient', params: { id: patient._id }})
        //this.$store.dispatch('allPatients')
      } else {
        alert('Failed to set default patient')
      }
    },
    gotoNewPatient() {
      this.$router.push({ name: 'newPatient'})
    },
    setUserLang: async function (e) {
      let currentUser = await StorageService.getItem('user')
      if (currentUser) {
        currentUser = JSON.parse(currentUser)
       
      } else {
        currentUser = await UserService.me()
        currentUser = currentUser.data
        if (currentUser == null)
          this.$miniToastr.error(this.$t("flash.failedToSaveLang"))
      }
      currentUser.language = e.currentTarget.getAttribute('data-lang')
      currentUser.currentEmail = currentUser.email
      let result = await UserService.update(currentUser)
      if (result) {
        this.$cookies.set("dravet_language",currentUser.language,"30d")
        if (currentUser.language) {
          this.$i18n.locale = currentUser.language
          this.currentLocale = currentUser.language
        }
        this.$miniToastr.success(this.$t("flash.langSaved"))
      } else {
        this.$miniToastr.error(this.$t("flash.failedToSaveLang"))
      }
    }
  }

}
</script>

<style>
.default-patient {
  font-weight: bold !important;
}
</style>
